import { LOCALES } from '../constants/intl';

export default LOCALES.reduce((langpackLoader, locale) => ({
  ...langpackLoader,
  // eslint-disable-next-line prefer-template
  [locale]: () => import('../locale/' + locale + '.json'),
}), {});
